"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const initialFaces_1 = require("../../data/initialFaces");
const ruleToApply_1 = __importDefault(require("./ruleToApply"));
const ruleApplications_1 = require("./ruleApplications");
/*
Take a project, set up initial shape, apply rules up to some limits, return a array of array of Faces
(i.e. different steps in evaluation) to be converted into actual Geometries
 */
exports.default = (project, iterationLimit = 10) => {
    const result = [];
    let step = 0;
    const ruleLookup = lodash_1.default.keyBy(project, "ruleKey");
    const startRule = project[0];
    let initial;
    switch (startRule.operation) {
        case "root":
            initial = initialFaces_1.initialCube(startRule.colour, startRule.scale);
            break;
        case "tetraRoot":
            initial = initialFaces_1.initialTetra(startRule.colour, startRule.scale);
            break;
        case "squareRoot":
            initial = initialFaces_1.initialSquare(startRule.colour, startRule.scale);
            break;
        default:
            throw new Error(`Start rule not recognised${startRule.operation}`);
    }
    result.push(lodash_1.default.clone(initial));
    let active = [];
    let inactive = [];
    initial.forEach((f, i) => {
        const nextRule = ruleToApply_1.default(startRule, i, ruleLookup);
        if (nextRule) {
            active.push([f, nextRule]);
        }
        else {
            inactive.push(f);
        }
    });
    while (step < iterationLimit) {
        let newActive = [];
        active.forEach(([face, rule]) => {
            switch (rule.operation) {
                case "pop":
                    updateFaces(ruleApplications_1.pop(face, rule.scale, rule.colour, 1.0), newActive, inactive, rule, ruleLookup);
                    break;
                case "smallPop":
                    updateFaces(ruleApplications_1.pop(face, rule.scale, rule.colour, 0.5), newActive, inactive, rule, ruleLookup);
                    break;
                case "bigPop":
                    updateFaces(ruleApplications_1.pop(face, rule.scale, rule.colour, 2.0), newActive, inactive, rule, ruleLookup);
                    break;
                case "randomPop":
                    updateFaces(ruleApplications_1.pop(face, rule.scale, rule.colour, 0.5 + Math.random()), newActive, inactive, rule, ruleLookup);
                    break;
                case "pyramid":
                    updateFaces(ruleApplications_1.pyramid(face, rule.scale, rule.colour), newActive, inactive, rule, ruleLookup);
                    break;
                case "truncatedPyramid":
                    updateFaces(ruleApplications_1.truncatedPyramid(face, rule.scale, rule.colour), newActive, inactive, rule, ruleLookup);
                    break;
                case "bevel":
                    updateFaces(ruleApplications_1.bevel(face, rule.scale, rule.colour), newActive, inactive, rule, ruleLookup);
                    break;
                case "jump":
                    updateFaces(ruleApplications_1.jump(face, rule.scale, rule.colour), newActive, inactive, rule, ruleLookup);
                    break;
                case "twist":
                    updateFaces(ruleApplications_1.twist(face, rule.scale, rule.colour, Math.PI / 4), newActive, inactive, rule, ruleLookup);
                    break;
                case "smallTwist":
                    updateFaces(ruleApplications_1.twist(face, rule.scale, rule.colour, Math.PI / 8), newActive, inactive, rule, ruleLookup);
                    break;
                case "randomTwist":
                    updateFaces(ruleApplications_1.twist(face, rule.scale, rule.colour, Math.PI * 2 * Math.random()), newActive, inactive, rule, ruleLookup);
                    break;
                default:
                    throw new Error(`Unrecognised/unsupported rule: ${JSON.stringify(rule)}`);
            }
        });
        result.push([...inactive, ...newActive.map(([f, _]) => f)]);
        active = newActive;
        step++;
    }
    return result;
};
const updateFaces = ({ active, inactive }, activeList, inactiveList, rule, ruleLookup) => {
    active.forEach((f, i) => {
        const nextRule = ruleToApply_1.default(rule, i, ruleLookup);
        if (nextRule) {
            activeList.push([f, nextRule]);
        }
        else {
            inactiveList.push(f);
        }
    });
    inactive.forEach(f => inactiveList.push(f));
};



// WEBPACK FOOTER //
// ./src/components/three/applyRules.ts